/**
 * WordPress dependencies
 */
import { PanelBody } from '@wordpress/components';
import { InspectorControls } from '@wordpress/block-editor';

import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
const { ColorControl, BorderControl, ResBoxControl, TypographyControl, ResRangeControl } = window.faqmateModules;

// obj attributes
import objAttributes from './attributes';

// constants
import { G_TYPO, G_MARGIN, ICON_WIDTH, ICON_HEIGHT, C_BORDER, C_BRADIUS } from './constants';

const Inspector = props => {
    const { attributes, setAttributes } = props;
    const {
        // style

        iconColor,
        textColor
    } = attributes;

    const objAttrs = { attributes, setAttributes, objAttributes };

    return (
        <InspectorControls key="inspector">
            <PanelBody title={__('Container', 'faqmate-blocks')} initialOpen={false}>
                <BorderControl objAttrs={objAttrs} controlName={C_BORDER} noHover={true} />
                <ResBoxControl label={__('Radius', 'faqmate-blocks')} objAttrs={objAttrs} controlName={C_BRADIUS} />
                <ResBoxControl label={__('Margin', 'faqmate-blocks')} controlName={G_MARGIN} objAttrs={objAttrs} />
            </PanelBody>
            <PanelBody title={__('Text', 'faqmate-blocks')} initialOpen={false}>
                <ColorControl
                    label={__('Text Color', 'faqmate-blocks')}
                    color={textColor}
                    onChange={v => {
                        setAttributes({ textColor: v });
                    }}
                />

                <TypographyControl label={__('Typography', 'faqmate-blocks')} objAttrs={objAttrs} controlName={G_TYPO} />
            </PanelBody>
            <PanelBody title={__('Icon', 'faqmate-blocks')} initialOpen={false}>
                <ColorControl
                    label={__(' Color', 'faqmate-blocks')}
                    color={iconColor}
                    onChange={v => {
                        setAttributes({ iconColor: v });
                    }}
                />
                <ResRangeControl
                    label={__('width', 'faqmate-blocks')}
                    controlName={ICON_WIDTH}
                    objAttrs={objAttrs}
                    min={1}
                    max={2000}
                    units={['px', '%', 'em', 'rem']}
                />
                <ResRangeControl
                    label={__('height', 'faqmate-blocks')}
                    controlName={ICON_HEIGHT}
                    objAttrs={objAttrs}
                    min={1}
                    max={2000}
                    units={['px', '%', 'em', 'rem']}
                />
            </PanelBody>
        </InspectorControls>
    );
};

export default Inspector;
